// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3cd22c73","732":"5aec1711","977":"3f765ab9"}[chunkId] + ".chunk.js";
};